<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router";
import type LxcError from "~/core/models/LxcError.class";

defineProps<{
  name?: string;
  shouldNotTranslate?: boolean;
  backRoute?: RouteLocationRaw;
  backDefaultRoute?: RouteLocationRaw;
  backExcludeRoutes?: RouteLocationRaw[];
  isLoading?: boolean;
  error?: LxcError | null;
  px?: number;
  py?: number;
  checkLicense?: boolean;
}>();

const breadcrumbContainerRef = ref();
const containerComponentRef = ref();

defineExpose({
  breadcrumbContainerRef,
  containerComponentRef,
});
</script>

<template>
  <div ref="breadcrumbContainerRef" class="flex justify-between mx-8 mt-8">
    <div class="flex items-center">
      <breadcrumb-component
        :name="name"
        :should-not-translate="shouldNotTranslate"
        :back-route="backRoute"
        :back-default-route="backDefaultRoute"
        :back-exclude-routes="backExcludeRoutes"
      >
        <template #default>
          <slot name="breadcrumb" />
        </template>
      </breadcrumb-component>
      <slot name="subtitle"></slot>
    </div>

    <slot name="top-right" />
  </div>

  <container-component
    ref="containerComponentRef"
    :is-loading="isLoading"
    :error="error"
    :px="px"
    :py="py"
  >
    <slot name="default" />
  </container-component>

  <div v-if="checkLicense" class="absolute w-full">
    <div class="m-4">
      <license-warning />
    </div>
  </div>
</template>
